import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RoutesPaths } from "../Router/Constant";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

export default function Header() {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [selectedLang, setSelectedLang] = useState(i18n.language);
  const [activeSection, setActiveSection] = useState("hero");
  const [menuVisible, setMenuVisible] = useState(false);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setSelectedLang(lang);
  };

  useEffect(() => {
    const sectionFromUrl = searchParams.get("section");
    if (!sectionFromUrl) return;

    const el = document.getElementById(sectionFromUrl);
    if (el) {
      const headerOffset = 60;
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      setActiveSection(sectionFromUrl);
    }
  }, [searchParams]);

  const scrollToSection = (id) => {
    setActiveSection(id);
    const el = document.getElementById(id);
    if (el) {
      const headerOffset = 80;
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
      setMenuVisible(false);
    } else {
      navigate(`${RoutesPaths.LANDING}?section=${id}`);
    }
  };

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  const gotoHomePage = () => {
    navigate(`${RoutesPaths.LANDING}`);
    setActiveSection("hero");
  };
  return (
    <div className="fixedHeaderSection">
      <div className="container-fluid maxContainerSection">
        <div className="row">
          <div className="col-md-12">
            <div className="headerSection">
              <div className="logoOuter">
                <div className="smsLogo" onClick={gotoHomePage}>
                  <img src="/assets/img/smsLogo.svg" alt="" />
                </div>
                <img
                  src="/assets/img/menu-stroke.svg"
                  alt=""
                  onClick={toggleMenu}
                  className="visibleMobile"
                  style={{ cursor: "pointer" }}
                />
              </div>

              <div
                className={`navCenterSection ${
                  menuVisible ? "showMenu" : "hideMenu"
                }`}
              >
                <p
                  className={`m-0 ${
                    activeSection === "hero" ? "navActiveClass" : ""
                  }`}
                  onClick={() => scrollToSection("hero")}
                >
                  {t("home")}
                </p>
                <p
                  className={`m-0 ${
                    activeSection === "whySmsHub" ? "navActiveClass" : ""
                  }`}
                  onClick={() => scrollToSection("whySmsHub")}
                >
                  {t("why_smshub")}
                </p>
                <p
                  className={`m-0 ${
                    activeSection === "features" ? "navActiveClass" : ""
                  }`}
                  onClick={() => scrollToSection("features")}
                >
                  {t("features")}
                </p>
                <p
                  className={`m-0 ${
                    activeSection === "useCases" ? "navActiveClass" : ""
                  }`}
                  onClick={() => scrollToSection("useCases")}
                >
                  {t("use_cases")}
                </p>
                <p
                  className={`m-0 ${
                    activeSection === "steps" ? "navActiveClass" : ""
                  }`}
                  onClick={() => scrollToSection("steps")}
                >
                  {t("how_it_works")}
                </p>
                <p
                  className={`m-0 ${
                    activeSection === "pricing" ? "navActiveClass" : ""
                  }`}
                  onClick={() => scrollToSection("pricing")}
                >
                  {t("pricing")}
                </p>
              </div>
              <div className="rightRegisterSection">
                <div className="setLanguageSec">
                  <div className="authSelectorLanguage">
                    {selectedLang === "en" ? (
                      <div
                        className="innerSelectorLang"
                        onClick={() => changeLanguage("pt")}
                      >
                        <img
                          src="https://flagcdn.com/48x36/pt.png"
                          alt="Portugal Flag"
                        />
                        <p className="m-0">Portuguese</p>
                      </div>
                    ) : (
                      <div
                        className="innerSelectorLang"
                        onClick={() => changeLanguage("en")}
                      >
                        <img
                          src="https://flagcdn.com/48x36/us.png"
                          alt="USA Flag"
                        />
                        <p className="m-0">English</p>
                      </div>
                    )}
                  </div>
                </div>

                <div className="registerLoginSection">
                  <Link
                    to="https://app.smshubangola.com/register"
                    target="_blank"
                    rel="noreferrer"
                    className="getStartedbtnLink widthFull"
                  >
                    <button className="registerButton">{t("register")}</button>
                  </Link>
                  <Link
                    to="https://app.smshubangola.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="getStartedbtnLink widthFull"
                  >
                    <button className="registerButton">{t("login")}</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
